import { render, staticRenderFns } from "./UserDetailsLayout.vue?vue&type=template&id=2d2b4fa2&"
import script from "./UserDetailsLayout.vue?vue&type=script&lang=js&"
export * from "./UserDetailsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports